import {selectNavOption} from "../helpers/nav_option_helpers";
import {clearNavOption, setRenderMapBounds} from "../helpers/commit_helpers";

// When the nav option is clicked (via the Nav's `PaneOptionComponent`) we change the URL without calling the route handler (using the `callHandler` option) and then we do the same work as the route handler would.
// However, unlike the route handlers we don't call the Nav Option's `fireSelectedWithRouteRequestEvent` method.
// This is important because firing that would trigger the Nav's `PaneOptionComponent` to handle the event -
// which is not necessary as the initial `click` event on the Nav's `PaneOptionComponent` will do it's thing appropriately.
export default function navOptionClicked(sm, navOption) {

    if (navOption.experience && navOption.mapFilter) {

        // Change the URL to the filter experience route without calling the route handler.
        navOption.onlineApp.onlineAppRouter.navigateToFilterExperience(navOption.mapFilter, navOption.experience, { callHandler: false });

        // The navOption may have map bounds (triggering a map pan/zoom).
        // When a filter experience route is requested we don't wish for this to happen.
        // So we temporarily true off the rendering of map bounds.
        setRenderMapBounds(sm, false);
        selectNavOption(sm, navOption);
        setRenderMapBounds(sm, true);

    } else if (navOption.mapFilter) {

        // Change the URL to the filter route without calling the route handler.
        navOption.onlineApp.onlineAppRouter.navigateToFilter(navOption.mapFilter, { callHandler: false });

        selectNavOption(sm, navOption);

    } else if (navOption.subpage) {

        // Change the URL to the subpage route without calling the route handler.
        navOption.onlineApp.onlineAppRouter.navigateToSubpage(navOption.subpage, { callHandler: false });

        selectNavOption(sm, navOption);

    } else if (navOption) {
        selectNavOption(sm, navOption);
    } else {
        if (!!sm.state['navOption']) clearNavOption(sm);
    }

}